import {Component} from '@angular/core';

@Component({
  selector: 'mz-dropdown-item',
  templateUrl: './dropdown-item.component.html',
  styleUrls: ['./dropdown-item.component.scss'],
})
export class MzDropdownItemComponent {
}
